import { render } from "./carousel.vue?vue&type=template&id=207ed0b2&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=207ed0b2&lang=scss&scoped=true"
import "./carousel.vue?vue&type=style&index=1&id=207ed0b2&lang=scss"
script.render = render
script.__scopeId = "data-v-207ed0b2"

export default script